import request from '@/utils/request'

const baseUrl = '/erp/sales/outbound'

export const pageSalesOutbound = params => request({ url: baseUrl + '/page', method: 'get', params })
export const getSalesOutbound = id => request({ url: baseUrl + '/detail', method: 'get', params: { id } })
export const pageOutboundSourceOrders = params => request({ url: baseUrl + '/source-orders', method: 'get', params })
export const getOutboundSourceItems = orderId => request({ url: baseUrl + '/source-items', method: 'get', params: { orderId } })
export const getReturnSourceItems = orderId => request({ url: baseUrl + '/return-source-items', method: 'get', params: { orderId } })
export const createSalesOutbound = data => request({ url: baseUrl + '/add', method: 'post', data })
export const updateSalesOutbound = data => request({ url: baseUrl + '/edit', method: 'post', data })
export const auditSalesOutbound = id => request({ url: baseUrl + '/audit', method: 'post', data: { id } })
export const reverseAuditSalesOutbound = id => request({ url: baseUrl + '/reverse-audit', method: 'post', data: { id } })
export const voidSalesOutbound = id => request({ url: baseUrl + '/void', method: 'post', data: { id } })
export const deleteSalesOutbound = id => request({ url: baseUrl + '/delete', method: 'post', data: { id } })
export const printSalesOutbound = id => request({
  url: baseUrl + '/print',
  method: 'get',
  params: { id },
  responseType: 'blob'
})
